import React from 'react';
import { motion } from 'framer-motion';
export function Founder() {
  return <section className="py-32 bg-ivory text-midnight relative overflow-hidden" data-id="element-161" data-mp="3ge1si9zib9qd">
      {/* Decorative background text */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full overflow-hidden pointer-events-none opacity-[0.03]" data-id="element-162" data-mp="31pxa774d9084">
        <h2 className="text-[20vw] font-display font-black whitespace-nowrap text-center leading-none" data-id="element-163" data-mp="36mfds3nymsiv">
          FOUNDER
        </h2>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-164" data-mp="2xo3cn7pgwcc6">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-165" data-mp="2xl7h1q13dzqw">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight text-gold rounded-full text-xs font-bold tracking-widest uppercase mb-12 rotate-[-2deg] shadow-lg" data-id="element-166" data-mp="gx3m3ibcbshw">
            Founded 2019 • UNIBEN
          </div>

          <div className="relative max-w-4xl mx-auto" data-id="element-167" data-mp="1xe4y48gsbcx0">
            <span className="absolute -top-16 -left-10 text-8xl font-serif text-gold/30 select-none" data-id="element-168" data-mp="1xbirqc5mr3gd">
              "
            </span>
            <p className="text-3xl md:text-5xl lg:text-6xl font-serif italic leading-[1.3] text-midnight" data-id="element-169" data-mp="272wkm132t50j">
              Founded following profound spiritual encounters in 2017 and 2018.
              The ministry officially began its journey in January 2019 at the
              University of Benin with just three members. Today, it has grown
              into a global movement of intercessors.
            </p>
            <span className="absolute -bottom-16 -right-10 text-8xl font-serif text-gold/30 select-none rotate-180" data-id="element-170" data-mp="1ocovimw7of3c">
              "
            </span>
          </div>

          <div className="mt-16 flex flex-col items-center" data-id="element-171" data-mp="2zs3t9sw8vazi">
            <div className="w-16 h-1 bg-gold rounded-full mb-6" data-id="element-172" data-mp="2zrkegl1w52pp" />
            <h3 className="text-2xl font-display font-bold tracking-tight" data-id="element-173" data-mp="1whzf02zl8k8p">
              Ajayi, Osagioduwa Joseph
            </h3>
            <p className="text-sm font-bold tracking-widest uppercase text-charcoal/50 mt-2" data-id="element-174" data-mp="21epxewyv7rxa">
              Founder
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}